module.exports = __webpack_public_path__ + "img/12.387e4dd6.png";